import React from "react";
import { Helmet } from "react-helmet";
import MainImage from "../../assets/MainImage.jpg";
import Footer from "../../components/Footer";
import SecondImage from "../../assets/AboutImage4.jpg";
import Navbar from "../../components/NavLite";
import PastWord from "../../components/PastWord";
import SmallTestimony from "../../components/SmallTestimony";

function FortWorth() {
  return (
    <section>
<Helmet>
  <title>Fort Worth SEO Web Design for Women Entrepreneurs | Woaom Web Design</title>
  <meta
    name="description"
    content="Woaom Web Design creates stylish, strategic, and SEO-powered websites for women entrepreneurs and female founders in Fort Worth, Texas. Custom, mobile-friendly, and built to convert."
  />
  <meta
    name="keywords"
    content="Fort Worth web design for women entrepreneurs, Fort Worth TX female founder websites, Fort Worth women-owned business websites, SEO web design Fort Worth Texas, custom websites for women-led brands Fort Worth, branding for women entrepreneurs Fort Worth TX, creative agency for women in Fort Worth, upscale website design Fort Worth TX, Fort Worth mobile-first websites, professional websites for Fort Worth women in business, strategic web design Fort Worth TX, tailored websites for Fort Worth female founders, Fort Worth TX digital strategy and branding, modern website packages Fort Worth TX, elegant website design Fort Worth women entrepreneurs, Fort Worth startup web design for women, Fort Worth TX personal brand websites, high-converting websites Fort Worth TX, Fort Worth founder-focused design studio, Fort Worth women in tech web design, Fort Worth conversion-optimized websites, React website design Fort Worth TX, scalable websites for Fort Worth startups, premium website design for Fort Worth business women, Fort Worth TX creative web design studio, women-led business websites Fort Worth, Fort Worth SEO websites for women-owned brands, digital presence for Fort Worth entrepreneurs, Fort Worth professional services website design, Fort Worth Texas custom web development for women founders"
  />
</Helmet>


      {/* Hero Section */}
      <div
        className="relative h-auto bg-cover bg-center"
        style={{
          clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
          backgroundImage: `url(${MainImage})`,
          padding: "20px",
          width: "100%",
        }}
      >
        <Navbar />
        <div className="p-10">
          <h2 className="text-3xl font-bold uppercase text-black mb-4 text-center">
            <span className="bg-[#CFF098] italic">
              Fort Worth Web Design & SEO for Women Entrepreneurs
            </span>
          </h2>
        </div>
      </div>

      {/* CTA Section */}
      <div className="mx-auto w-full max-w-7xl px-5 py-6 md:px-10 md:py-10 flex flex-col items-center text-center">
        <p className="text-gray-200 mb-4 text-2xl max-w-2xl">
          Based in Fort Worth? We build stunning websites and data-driven SEO strategies to help women entrepreneurs grow their businesses with confidence.
        </p>
        <a href="https://cal.com/woaomwebdesign/15min">
          <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black">
            BOOK A FREE STRATEGY CALL →
          </button>
        </a>
      </div>





     {/* Our Process */}
<div className="mx-auto w-full max-w-7xl flex flex-col items-center text-center mt-20">
  <h2 className="text-3xl font-medium md:text-4xl text-white uppercase">
    Our Process
  </h2>
</div>

{/* Centered Paragraph below heading */}
<p className="mx-auto mt-4 max-w-3xl text-sm text-gray-200 sm:text-base md:mb-12 lg:mb-16 text-center">
  We work closely with Fort Worth women entrepreneurs to craft websites that tell your story and attract your perfect clients.
</p>

<div className="flex flex-col md:flex-row items-stretch gap-8 md:gap-12">
  {/* Text Section */}
  <div className="flex flex-col justify-center w-full md:w-1/2">
    {[
      {
        step: 1,
        title: "Initial Consultation",
        desc: "Exploring your Fort Worth business goals and brand identity to lay the groundwork.",
      },
      {
        step: 2,
        title: "Creative Design",
        desc: "Designing a visually compelling, mobile-friendly website tailored to your clients.",
      },
      {
        step: 3,
        title: "Fort Worth SEO Strategy",
        desc: "Implementing SEO techniques focused on Fort Worth to maximize your reach.",
      },
      {
        step: 4,
        title: "Launch & Growth",
        desc: "Launching your site and continuing SEO optimization to grow your impact steadily.",
      },
    ].map(({ step, title, desc }) => (
      <div key={step} className="mb-8 flex max-w-lg justify-center gap-4 px-6 py-5 text-black">
        <div className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-gray-100">
          <p className="text-sm font-bold sm:text-base">{step}</p>
        </div>
        <div className="ml-4 flex flex-col gap-2">
          <h5 className="text-xl font-medium uppercase text-white">{title}</h5>
          <p className="text-sm text-gray-200">{desc}</p>
        </div>
      </div>
    ))}
  </div>

  {/* Image Section */}
  <div className="w-full md:w-1/2 flex items-stretch">
    <img
      alt="e-commerce funnel template, shopify sales funnel, digital product sales page, 
digital product template, Gumroad product page template, lead magnet funnel for coaches, React product landing page, passive income website template, stripe checkout website, course sales funnel"
      src={MainImage}
      className="w-full object-cover"
    />
  </div>
</div>






      {/* Past Work & Testimonials */}
      <PastWord />
      <SmallTestimony />

      {/* About Us Section */}
      <div className="mx-auto w-full">
        <div className="grid gap-6 sm:gap-6 md:grid-cols-2">
          <div className="flex flex-col items-start gap-2 md:py-24 md:px-24 max-w-[600px] p-4">
            <div className="flex items-center rounded-md py-1">
              <p className="text-sm uppercase mb-12">ABOUT US</p>
            </div>
            <h4 className="mb-6 text-2xl font-semibold md:text-3xl md:mb-8 uppercase">
              Helping{" "}
              <span className="italic text-black bg-[#CFF098]">
                Fort Worth Women Entrepreneurs
              </span>{" "}
              Show Up Powerfully{" "}
              <span className="italic text-black bg-[#CFF098]">
                Online & in Search.
              </span>
            </h4>
            <p className="text-sm text-white sm:text-xl">
              Our specialty? Building clean, strategic websites and delivering SEO results for women-led businesses in Fort Worth. Whether you're a coach, creative, or consultant, we help you reach the next level.
              <br />
              <br />
              We know the Fort Worth market and what it takes for women to win online. That’s why we tailor everything to fit your voice, goals, and audience.
            </p>
            <p className="mt-6 mb-6 text-xl italic uppercase">
              Your brand deserves to shine.{" "}
              <span className="italic">We’ll help you make it happen.</span>
            </p>

            <div className="flex flex-col gap-4 font-regular sm:flex-row">
              <a
                href="/about"
                className="flex rounded-full items-center gap-4 bg-[#CFF098] px-8 py-2 text-black hover:opacity-60 text-sm"
              >
                <p>LEARN MORE ABOUT US →</p>
              </a>
            </div>
          </div>

          <div className="relative w-full h-[]">
            <img
              src={SecondImage}
              alt="web design for women entrepreneurs, feminine website design, launch-ready website, low tech funnel, no code website template, simple website for coaches, website for mindset coach, 
template for spiritual entrepreneurs, web app for service-based business, women-owned business website
"
              className="absolute top-0 right-0 w-auto h-full object-cover"
            />
          </div>
        </div>
      </div>

      <Footer />
    </section>
  );
}

export default FortWorth;
